module.exports = __webpack_public_path__ + "img/Stage_4_Diff.b0a4cff9.jpg";